import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\YosefMajadley\\source\\repos\\Codit_ECommerce.CLIENT\\web\\src\\components\\loader.tsx");
